// CRA injected regeneratorRuntime; Vite does not. react-speech-recognition@3
// ships async generators that expect the global.
import "regenerator-runtime/runtime";
import { ColorModeScript } from "@chakra-ui/react";
import "config/axios";
import { ContextsProvider } from "contexts";
import * as React from "react";
import { createRoot } from "react-dom/client";
import { theme } from "theme";
import { App } from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const container = document.getElementById("root");
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <ColorModeScript
      initialColorMode={theme.config.initialColorMode}
      type="cookie"
    />
    <ContextsProvider>
      <App />
    </ContextsProvider>
  </React.StrictMode>
);

// PWA/service worker registration is deferred after CRA→Vite migration.
// CRA Workbox injectManifest is not wired; re-enable with vite-plugin-pwa later.
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
